import { useEffect } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { setViewAsId } from '@/lib/api';
import Sidebar from './Sidebar';
import Header from './Header';
import ForecastGate from '@/components/ForecastGate';
import AppSwitcher, { AppSwitcherMobile } from '@/my/components/AppSwitcher';
import useSidebarCollapsed from '@/shared/useSidebarCollapsed';
import usePushSounds from '@/hooks/usePushSounds';
import IncentivoPromoPopup from '@/components/IncentivoPromoPopup';

export default function AppLayout() {
  const { user, loading, viewingUser } = useAuth();
  const [sidebarCollapsed, toggleSidebar] = useSidebarCollapsed('crm_sidebar_collapsed');
  usePushSounds();

  // Sync viewingUser with api interceptor
  useEffect(() => {
    setViewAsId(viewingUser ? viewingUser.ID_Cliente : null);
  }, [viewingUser]);

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-[#F9FAFB]">
        <div className="w-8 h-8 border-2 border-[#0F1829] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  return (
    <ForecastGate>
      <AppSwitcher current="crm" isConsultor isDBAdmin={!!user?.IsDBAdmin} theme="light" />
      <AppSwitcherMobile current="crm" isConsultor isDBAdmin={!!user?.IsDBAdmin} theme="light" />
      <div className="min-h-screen bg-[#F9FAFB] lg:pl-[72px] pb-[72px] lg:pb-0">
        <Sidebar collapsed={sidebarCollapsed} onToggle={toggleSidebar} />
        <div className={`transition-all duration-200 ${sidebarCollapsed ? 'lg:ml-[72px]' : 'lg:ml-[260px]'}`}>
          <Header onMenuToggle={toggleSidebar} />
          <main className="p-3 sm:p-4 lg:p-6 overflow-x-hidden">
            <Outlet />
          </main>
        </div>
      </div>
      <IncentivoPromoPopup />
    </ForecastGate>
  );
}
